/*
 *******************************************************************************
 * 
 *  Filename:   ./reducers/Components.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Component Reducers 
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *  
 *  Created:    Monday, September 17, 2018 - 12:11 PM (CST)
 *
 *  Notes:
 *
 *
 *  Revisions:
 *      09/17/2018  NJN     File Created
 *      
 *      
 *  Copyright (c) 2018 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import {
    COMPONENT_LIST_CONTAINER_LOADED,
    COMPONENT_LIST_CONTAINER_UNLOADED,
    COMPONENT_LIST_TABLE_LOADED,
    COMPONENT_LIST_TABLE_UNLOADED,
    COMPONENT_LIST_CHANGE_COMPONENT_GROUP,
    COMPONENT_SELECT_ROW,
    COMPONENT_ADD,
    COMPONENT_EDIT,
    COMPONENT_DELETE,
    COMPONENT_DELETE_DISABLE,
    COMPONENT_OPEN_WARNING,
    COMPONENT_CLOSE_WARNING,
    COMPONENT_VIEW_PAGES,
    COMPONENT_SET_COMPONENT_GROUP_SELECT,
    COMPONENT_EDIT_CONTAINER_LOADED,
    COMPONENT_EDIT_CONTAINER_UNLOADED,
    COMPONENT_EDIT_FORM_LOADED,
    COMPONENT_EDIT_FORM_UNLOADED,
    COMPONENT_EDIT_DATA_LOAD,
    COMPONENT_EDIT_CONTAINER_SUBMIT,
    COMPONENT_EDIT_CONTAINER_CANCEL
} from '../constants/actionTypeComponents';

const defaultState = {
    refreshList: false,
    componentgroups: [],
    danger: false,
    componentid: 0,
    componentgroupid: 0,
    name: '',
    description: '',
    createdate: '',
    modifydate: ''
};

export default (state = defaultState, action) => {
    switch (action.type) {
        case COMPONENT_LIST_CONTAINER_LOADED:
            return {
                ...state,
                inProgress: false,
                errors: action.error ? action.payload.errors : null,
                components: action.payload[0] ? action.payload[0].records : [],
                componentgroups: action.payload[1] ? action.payload[1].componentgroups : []
            }
        case COMPONENT_LIST_CHANGE_COMPONENT_GROUP:
            return {
                ...state,
                inProgress: false,
                errors: action.error ? action.payload.errors : null,
                components: action.payload[0] ? action.payload[0].records : []
            }
        case COMPONENT_LIST_TABLE_LOADED:
            return {
                ...state
            }
        case COMPONENT_SELECT_ROW:
            return {
                ...state,
                componentid: action.id
            }
        case COMPONENT_ADD:
            return {
                ...state
            }
        case COMPONENT_EDIT:
            return {
                ...state,
                componentid: action.id
            }
        case COMPONENT_DELETE:
            return {
                ...state,
                componentid: null
            }
        case COMPONENT_DELETE_DISABLE:
            return {
                ...state,
                disableDelete: action.disabled
            }
        case COMPONENT_OPEN_WARNING:
            return {
                ...state,
                danger: true
            }
        case COMPONENT_CLOSE_WARNING:
            return {
                ...state,
                danger: false
            }
        case COMPONENT_VIEW_PAGES:
            return {
                ...state
            }
        case COMPONENT_SET_COMPONENT_GROUP_SELECT:
            return {
                ...state,
                groupOptions: action.payload ? action.payload : []
            }
        case COMPONENT_EDIT_CONTAINER_LOADED:
            return {
                ...state,
                componentgroups: action.payload[1] ? action.payload[1].componentgroups : [],
                componentid: action.payload[0] ? action.payload[0].componentid : 0,
                componentgroupid: action.payload[0] ? action.payload[0].componentgroupid : 0,
                name: action.payload[0] ? action.payload[0].name : '',
                description: action.payload[0] ? action.payload[0].description : '',
                createdate: action.payload[0] ? action.payload[0].createdate : '',
                modifydate: action.payload[0] ? action.payload[0].modifydate : ''
            }
        case COMPONENT_EDIT_DATA_LOAD:
            return {
                ...state,
                componentid: action.payload ? action.payload.componentid : 0,
                componentgroupid: action.payload ? action.payload.componentgroupid : 0,
                name: action.payload ? action.payload.name : '',
                description: action.payload ? action.payload.description : '',
                createdate: action.payload ? action.payload.createdate : '',
                modifydate: action.payload ? action.payload.modifydate : ''
            }
        case COMPONENT_EDIT_FORM_LOADED:
            return {
                ...state
            }
        case COMPONENT_EDIT_CONTAINER_SUBMIT:
            return {
                ...state
            }
        case COMPONENT_EDIT_CONTAINER_CANCEL:
            return {
                ...state
            }
        case COMPONENT_LIST_CONTAINER_UNLOADED:
        case COMPONENT_LIST_TABLE_UNLOADED:
        case COMPONENT_EDIT_CONTAINER_UNLOADED:
        case COMPONENT_EDIT_FORM_UNLOADED:
            return {};
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/Components.js